export default __webpack_public_path__ + "static/media/blueChat.fd0058aa.svg";